import { ChevronDown, ChevronRight } from "lucide-react";
import React from "react";

interface ExpandChevronProps {
  expanded: boolean;
  /** Wraps the icon in a real button with a tooltip — used by the inline edit row,
   *  whose surrounding row is not itself clickable. */
  asButton?: boolean;
  onToggle?: () => void;
}

const ExpandChevron: React.FC<ExpandChevronProps> = ({ expanded, asButton = false, onToggle }) => {
  const Icon = expanded ? ChevronDown : ChevronRight;

  if (asButton) {
    return (
      <button
        type="button"
        onClick={onToggle}
        title={expanded ? "Collapse" : "View sub-sections"}
        className="tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-align-middle"
      >
        <Icon className="tw-h-3.5 tw-w-3.5 tw-text-muted-foreground" />
      </button>
    );
  }

  return <Icon className="tw-h-3.5 tw-w-3.5 tw-inline-block tw-text-muted-foreground" />;
};

export default ExpandChevron;
